import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../infrastructure/auth0/useAuth';
import styled from 'styled-components';
import { Logo } from '../components/Logo';

const LandingPage = (): ReactNode => {
  const { t } = useTranslation();
  const { loginWithRedirect } = useAuth();

  return (
    <Main>
      <Container>
        <Logo
          variant="square"
          width={40}
          height="auto"
          style={{ display: 'block' }}
        />
        <Logo
          variant="landscape"
          width={300}
          height="auto"
          style={{ display: 'block' }}
        />
        <Button
          type="button"
          onClick={() => {
            loginWithRedirect();
          }}
        >
          {t('login')}
        </Button>
      </Container>
    </Main>
  );
};

const Main = styled.div`
  height: 100vh;
  display: flex;
  background: #000000;
  justify-content: center;
  align-items: center;
`;

const Container = styled.div`
  width: 465px;
  height: 290px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: #ffffff;
  border-radius: 5px;
`;

const Button = styled.button`
  width: 240px;
  height: 40px;
  margin-top: 40px;
  background-color: #003399;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  &:hover {
    opacity: 0.9;
  }
  &:focus {
    outline: none;
  }
`;

export { LandingPage };
